import { render, staticRenderFns } from "./Worklist.vue?vue&type=template&id=77d2e2bb&scoped=true&"
import script from "./Worklist.vue?vue&type=script&lang=ts&"
export * from "./Worklist.vue?vue&type=script&lang=ts&"
import style0 from "./Worklist.vue?vue&type=style&index=0&id=77d2e2bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d2e2bb",
  null
  
)

export default component.exports